/* Raw Water Co. v2 — ZIP delivery checker.
   Reads city/zip data from the city cards in the same section and reports a match. */
(function () {
  function initChecker(checker) {
    if (checker.dataset.zipInit) return;
    checker.dataset.zipInit = "1";
    var section = checker.closest("section");
    var input = checker.querySelector("[data-zip-input]");
    var btn = checker.querySelector("[data-zip-go]");
    var ok = checker.querySelector("[data-zip-ok]");
    var okText = checker.querySelector("[data-zip-ok-text]");
    var bad = checker.querySelector("[data-zip-bad]");
    var badText = checker.querySelector("[data-zip-bad-text]");

    // Build a zip -> city map from the rendered city cards.
    var map = {};
    section.querySelectorAll("[data-city]").forEach(function (card) {
      var city = card.getAttribute("data-city");
      (card.getAttribute("data-zips") || "").split(",").forEach(function (z) {
        var zip = z.trim();
        if (zip) map[zip] = city;
      });
    });

    function check() {
      var zip = (input.value || "").replace(/[^0-9]/g, "").slice(0, 5);
      input.value = zip;
      ok.hidden = true;
      bad.hidden = true;
      if (zip.length !== 5) return;
      var city = map[zip];
      if (city) {
        okText.textContent = "Great news — we deliver free to " + city + " (" + zip + ").";
        ok.hidden = false;
      } else {
        badText.textContent = "We don't reach " + zip + " just yet. Contact us to request your area.";
        bad.hidden = false;
      }
    }

    btn.addEventListener("click", check);
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") check(); });
    input.addEventListener("input", function () {
      input.value = input.value.replace(/[^0-9]/g, "").slice(0, 5);
      ok.hidden = true; bad.hidden = true;
    });
  }

  function initAll() { document.querySelectorAll("[data-zip-checker]").forEach(initChecker); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
